import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IStore } from '../../../../store.type';
import { Beneficiary, IRecipientScreen } from '../../utils/interface';
import { activateLoader, disableLoader, scrollToTop } from '@Redux/actions/ui-trigger';
import { CHEVRON_LEFT_ICON, CLOSE_POPUP_ICON, PERSONAL_INFORMATION_ICON } from '@Images';
import { screenSettings, totalSteps, RECIPIENT_SCREEN } from '../../utils/constants';
import { NF_SCREENS } from '../../root/screenConstants';
import { SelectRecipient } from './select-recipient/SelectRecipient';
import AddRecipient from './add-recipient/AddRecipient';
import { StepHeader, ModalFactory } from '@Components';
import { ParentContainer } from '../../styles';
import CancelPaymentModal from '../../utils/cancel-payment-modal';
import { getBeneficiaryByID } from '@Redux/actions/common';
import { changeNiumForexScreen, storeSelectedBeneId } from '@Redux/actions/nium-forex';
import { updateTempTransactionWithId } from '../../utils/util';
import { EmptyContainer } from './style';
import { SECONDARY_ROUTING_INITIAL_VALUE } from './utils';

const RecipientScreen: React.FC<IRecipientScreen> = (props): React.ReactElement => {
  const stepperData = screenSettings[NF_SCREENS.recipient as keyof typeof screenSettings];
  const SELECT_RECIPIENT_CONST = RECIPIENT_SCREEN.selectRecipient;
  const ADD_RECIPIENT_CONST = RECIPIENT_SCREEN.addRecipient;
  const [isRecipientAlreadyAdded, setIsRecipientAlreadyAdded] = useState<boolean>(false);
  const [countofRecipients, setCountOfRecipients] = useState<number>(0);
  const [beneList, setBeneList] = useState<Beneficiary[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const {
    getBeneficiaryByID,
    activateLoader,
    disableLoader,
    sourceCurrency,
    destinationCurrency,
    tempTransactionId,
    updateTempTransactionWithId,
    storeSelectedBeneId,
    scrollToTop,
    dispatch
  } = props;

  useEffect(() => {
    const fetchData = async () => {
      dispatch(activateLoader());
      const response = await dispatch(getBeneficiaryByID(null, true, destinationCurrency));
      dispatch(disableLoader());
      if (response?.data?.success) {
        if (response.data.data?.length > 0) {
          setCountOfRecipients(response.data.data.length);
          setIsRecipientAlreadyAdded(true);
          setBeneList(response.data.data);
        }
      }
      setIsLoading(false);
    };
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const showAddRecipientScreen = () => {
    dispatch(scrollToTop());
    setIsRecipientAlreadyAdded(false);
  };

  const navigateBackUser = () => {
    if (isRecipientAlreadyAdded) {
      //Select Recipient Screen
      dispatch(changeNiumForexScreen(NF_SCREENS.send_money));
    } else if (countofRecipients > 0) {
      //Add recipient screen - came from Select Recipient Screen
      setIsRecipientAlreadyAdded(true);
    } else {
      dispatch(changeNiumForexScreen(NF_SCREENS.send_money));
    }
  };

  const onCancelPayment = async () => {
    // @ts-ignore
    return await ModalFactory.builder?.(
      (onClose: any) => (
        <CancelPaymentModal
          onContinue={() => onClose(true)}
          postPan={false}
          onConfirm={() => {
            dispatch(changeNiumForexScreen(NF_SCREENS.send_money));
            onClose(true);
          }}
        />
      ),
      'center-modal insta-modal',
      true
    );
  };

  if (isLoading) {
    return <EmptyContainer />;
  }

  return (
    <ParentContainer padding={[30, 0, 48, 0]}>
      <div className="navigationContainer">
        <img className="backButton" src={CHEVRON_LEFT_ICON} alt="back" onClick={navigateBackUser} />
        <img className="closeButton" src={CLOSE_POPUP_ICON} alt="close" onClick={onCancelPayment} />
      </div>
      <StepHeader
        heading={
          isRecipientAlreadyAdded ? SELECT_RECIPIENT_CONST.heading : ADD_RECIPIENT_CONST.heading
        }
        headerLogo={PERSONAL_INFORMATION_ICON}
        stepNumber={stepperData?.stepNumber}
        totalSteps={totalSteps}
        subHeading={
          isRecipientAlreadyAdded
            ? SELECT_RECIPIENT_CONST.subHeading.replace('{XXX}', destinationCurrency || '')
            : countofRecipients > 0
            ? ''
            : ADD_RECIPIENT_CONST.subHeading.replace('{XXX}', destinationCurrency || '')
        }
      />
      {isRecipientAlreadyAdded ? (
        <SelectRecipient
          beneList={beneList}
          destinationCurrency={destinationCurrency || ''}
          showAddRecipientScreen={showAddRecipientScreen}
          changeNiumForexScreen={changeNiumForexScreen}
          tempTransactionId={tempTransactionId}
          updateTempTransactionWithId={updateTempTransactionWithId}
          storeSelectedBeneId={storeSelectedBeneId}
          activateLoader={activateLoader}
          disableLoader={disableLoader}
          dispatch={dispatch}
        />
      ) : (
        <AddRecipient
          isSendMoneyFlow
          isRecipientsAddFlow
          sourceCurrency={sourceCurrency}
          destinationCurrency={destinationCurrency}
          secondaryRoutingFields={SECONDARY_ROUTING_INITIAL_VALUE}
        />
      )}
    </ParentContainer>
  );
};

function mapStateToProps(reduxState: IStore) {
  const {
    rootReducer: {
      niumForexReducer: {
        transactionDetails: { sourceCurrency, destinationCurrency, tempTransactionId }
      }
    }
  } = reduxState;
  return { sourceCurrency, destinationCurrency, tempTransactionId };
}

export default connect(mapStateToProps, (dispatch: any) => {
  return {
    getBeneficiaryByID,
    changeNiumForexScreen,
    updateTempTransactionWithId,
    activateLoader,
    disableLoader,
    storeSelectedBeneId,
    scrollToTop,
    dispatch
  };
  //@ts-ignore
})(RecipientScreen);
